import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { TransitionGroup } from "react-transition-group";
import styles from "./Person.styl";
import Button from "../button/Button";
import Checkmark from "-!svg-react-loader!../../assets/Check_Mark_Reps.svg";
/* eslint import/no-webpack-loader-syntax: off */

class Person extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false
    };

    this.handleClick = this.handleClick.bind(this);
  }

  componentWillMount() {
    let testExp = new RegExp(
      "Android|webOS|iPhone|iPad|" +
        "BlackBerry|Windows Phone|" +
        "Opera Mini|IEMobile|Mobile",
      "i"
    );

    if (testExp.test(navigator.userAgent)) {
      this.setState({
        isMobile: true
      });
    } else {
      this.setState({
        isMobile: false
      });
    }
  }

  handleClick = () => {
    if (this.props.contactType === "email") {
      this.props.setSelectedMembers(this.props.index);
    }
  };

  render() {
    let props = this.props;
    let personClass = classnames(
      styles.personWrapper,
      styles[props.contactType]
    );
    let callTitle = props.contactType === "call" ? props.member.phone : "Call";
    return (
      <div className={personClass}>
        <div
          className={styles.imageBorder}
          style={{ borderColor: props.color }}
          onClick={this.handleClick}
        >
          <div
            className={classnames(props.selected ? styles.selected : "")}
            style={{
              backgroundColor: props.selected ? props.color : "",
              opacity: props.selected ? "0.8" : "1"
            }}
          >
            {props.selected ? (
              <Checkmark className={styles.checkmark} width={90} height={90} />
            ) : (
              ""
            )}
          </div>
          <img
            style={{ backgroundImage: "url(" + props.member.image + ")" }}
            alt=""
            className={styles.personImage}
          />
        </div>
        <h3 style={{ color: props.color }} className={styles.personName}>
          {props.member.name}
        </h3>
        <p style={{ color: props.color }} className={styles.personInfo}>
          ({props.member.party}-{props.member.state}) {props.member.title}
        </p>
        <TransitionGroup>
          <div>
            {props.contactType === "call" && this.state.isMobile === true && (
              <a href={`tel:${props.member.phone.replace(/\D+/g, "")}`}>
                <Button
                  title={callTitle}
                  color={props.color}
                  setContactType={props.setContactType}
                  type="call"
                  setSelectedMembers={props.setSelectedMembers}
                  index={props.index}
                />
              </a>
            )}
            {props.contactType === "call" && this.state.isMobile !== true && (
              <Button
                title={callTitle}
                color={props.color}
                setContactType={props.setContactType}
                type="call"
                setSelectedMembers={props.setSelectedMembers}
                index={props.index}
              />
            )}
            {(props.contactType === null || props.contactType === "thanks") && (
              <Button
                title={callTitle}
                color={props.color}
                setContactType={props.setContactType}
                type="call"
                completed={props.called}
              />
            )}
            {(!props.contactType || props.contactType === "thanks") && (
              <Button
                title={this.props.emailed ? "SENT" : "Email"}
                color={props.color}
                setContactType={props.setContactType}
                setSelectedMembers={props.setSelectedMembers}
                type="email"
                index={props.index}
                memberID={props.member.id}
                completed={props.emailed}
              />
            )}
          </div>
        </TransitionGroup>
      </div>
    );
  }
}

Person.propTypes = {
  member: PropTypes.object.isRequired,
  color: PropTypes.string
};

export default Person;



// WEBPACK FOOTER //
// ./src/components/person/Person.js